import Translate from "../../../translation/utils/translateFunction";
import { CustomTitleCellRender } from "../../common/CustomCellRender";

export const getVendorColumns = (
  customActionCellRender,
  customSrCellRender
) => {
  const columns = [
    {
      field: "lineNo",
      headerName: Translate("vendors:srNoTableHeading"),
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: customSrCellRender,
    },
    {
      field: "name",
      headerName: Translate("vendors:nameTableHeading"),
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => CustomTitleCellRender(params?.row?.name),
    },
    {
      field: "mobileWithCountryCode",
      headerName: Translate("vendors:mobileTableHeading"),
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      valueGetter: (params) => params.row?.mobile,
    },
    {
      field: "companyName",
      headerName: Translate("vendors:companyNameTableHeading"),
      flex: 0.6,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => CustomTitleCellRender(params?.row?.companyName),
    },
    {
      field: "Action",
      headerName: Translate("vendors:actionTableHeading"),
      flex: 0.3,
      sortable: false,
      disableColumnMenu: true,
      hide: true,
      renderCell: customActionCellRender,
    },
  ];
  return columns;
};
